<script lang="ts">
  import { Col, Form } from "sveltestrap";
  import Dropzone from "svelte-file-dropzone";
  let files = {
    accepted: [],
    rejected: [],
  };

  function handleFilesSelect(e) {
    const { acceptedFiles, fileRejections } = e.detail;
    files.accepted = [...files.accepted, ...acceptedFiles];
    files.rejected = [...files.rejected, ...fileRejections];
  }
</script>
<Form class="dropzone digits" id="singleFileUpload" action="/upload.php" novalidate>
    <div class="m-0 dz-message needsclick">
      <Col sm="12">
        <div class="dropzone-content">
          <Dropzone on:drop={handleFilesSelect} multiple={false} />
          <ol>
            {#each files.accepted as filesItem}
              <li>{filesItem.name}</li>
            {/each}
          </ol>
        </div>
      </Col>
    </div>
</Form>